import React from "react";

function SectorPerformance({ table_data }) {
  let data = [];
  let userLoging = {};
  let currencies = [];
  userLoging = JSON.parse(localStorage.getItem("user") || "{}");
  currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
  const selectedCurrency = currencies.find(
  (currency) =>
    Number(currency.value) === defaultCurrencyId
);
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
  const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
  const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;

  table_data?.forEach((item) => {
    let name = "";
    let target = 0;
    switch (item.industrymaster_id) {
      case 1:
        name = "BFSI/PE";
        target = item.target;
        break;
      case 2:
        name = "Infrastructure";
        target = item.target;
        break;
      case 3:
        name = "Consumer";
        target = item.target;
        break;
      case 4:
        name = "Communication";
        target = item.target;
        break;
      case 5:
        name = "Technology";
        target = item.target;
        break;
      case 7:
        name = "Healthcare";
        target = item.target;
        break;
      case 9:
        name = "Others";
        target = item.target;
        break;
    }
    data.push({
      sector: name,
      target: Math.round(target / amountDivisor, 0) + amountSuffix,
      netadd: (item.net_add / amountDivisor).toFixed(2) + amountSuffix,
      achievedValue: (item.curr_year_achievement / amountDivisor).toFixed(2) + amountSuffix,
      achieved: ((item.curr_year_achievement / target) * 100).toFixed(2) + " %",
      growth_rate:
            (Number(item.prev_year_achievement ?? 0) === 0
              ? (Number(item.curr_year_achievement ?? 0) !== 0 ? 100 : 0)
              : ((Number(item.curr_year_achievement ?? 0) -
                  Number(item.prev_year_achievement ?? 0)) /
                  Number(item.prev_year_achievement)) * 100
            ).toFixed(2),
      closed: item.total_closed,
      active: item.active_search,
      inactive: item.totShelved,
      new_clients: item.new_client,
      existing: item.old_client,
      bus_from_new: (item.new_business / amountDivisor).toFixed(2) + amountSuffix,
      bus_from_existing: (item.old_business / amountDivisor).toFixed(2) + amountSuffix,
      avg_vobt: (item.avg_vobt / amountDivisor).toFixed(2) + amountSuffix,
      avg_fee: item.avg_fee + " %",
      arpa: (item.ARPA / amountDivisor).toFixed(2) + amountSuffix,
      avg_fee_vobt: item.avg_fee_vobt + " %",
    });
  });

  return (
    <>
      <style>
        {`
                    .table thead tr th {
                        white-space: normal !important;
                        word-wrap: break-word;
                        padding: 6px 8px;
                    }

                    .table tbody tr td {
                    color : #202c4b;
                    }
                `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Sector</th>
              <th>Target</th>
              <th>Achieved</th>
              <th>Net Add</th>
              <th>% Achieved</th>
              <th>Growth Rate %</th>
              <th>Closed</th>
              <th>Active</th>
              <th>Inactive</th>
              <th>New Clients</th>
              <th>Existing</th>
              <th>Bus. from New</th>
              <th>Bus. from Existing</th>
              <th>Avg VOBT</th>
              <th>Avg Fee</th>
              <th>ARPA</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((item, index) => {
                return (
                  <tr key={index}>
                    <td><h6 className="fw-medium">{item.sector}</h6></td>
                    <td>{item.target}</td>
                    <td>{item.achievedValue}</td>
                    <td>{item.netadd}</td>
                    <td><h6 className="fw-medium">{item.achieved}</h6></td>
                    <td className={`${item.growth_rate > 0 ? "text-success" : "text-danger"}`}>
                      {item.growth_rate}%
                    </td>
                    <td>{item.closed}</td>
                    <td>{item.active}</td>
                    <td>{item.inactive}</td>
                    <td>{item.new_clients}</td>
                    <td>{item.existing}</td>
                    <td>{item.bus_from_new}</td>
                    <td>{item.bus_from_existing}</td>
                    <td>{item.avg_vobt}</td>
                    <td>{item.avg_fee}</td>
                    <td>{item.arpa}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default SectorPerformance;
